import ForecastCard from "./ForecastCard.jsx";

/** A watchlisted card. */
export function WatchlistRow(props) {
  return <ForecastCard {...props} watched />;
}
